<template>
  <section :class="termsConditionClass ? 'terms_condition_popup' : ''" @click="closePopUp">
    <div class="text-content">
      <h3>{{$t('TermsandConditions')}}</h3>
      <p v-html="$t('callRate')"></p> 
      <!-- <p v-html="$t('callTime')"></p> -->
      <p v-html="$t('minAmount')"></p>
      <h3>{{$t('Caution')}}</h3>
      <span>{{$t('nodirtyTalk')}}</span>
    </div>
  </section>
</template>
<script>
export default {
  name: "TermsConditions",
  props:{
    termsConditionClass: Boolean
  },
  methods:{
      closePopUp(){
        console.log('==termsConditionClass=',this.termsConditionClass)
        if(this.termsConditionClass){
          this.$emit('closePopUp')
        }
      }
  }
}
</script>